import { UpdateStaffBecomeEnabledDocument } from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useUpdateBecome() {
  const session = useCurrentSession()
  const [mutation, { loading }] = useMutation(UpdateStaffBecomeEnabledDocument, {
    extractorFn: (data) => data.securitySettingsMutations.updateSecuritysettingsCompanyConfig,
  })

  const updateBecome = useUnsafeCallback(
    (staffBecomeEnabled: boolean) => {
      return mutation({
        variables: {
          companyId: session.company.id,
          staffBecomeEnabled: staffBecomeEnabled,
        },
      })
    },
    [mutation, session.company.id]
  )

  return {
    updateBecome,
    loading,
  }
}
